module.exports = __webpack_public_path__ + "img/card_strair_down.9e2e91c2.gif";